import { api } from "@/lib/api";

/**
 * Thin API client for /api/workspace. Each method returns the parsed body.
 * Errors are propagated as thrown axios errors so callers can render them.
 */
export const workspaceApi = {
  listSessions: (includeArchived = false) =>
    api.get(`/workspace/sessions`, { params: { include_archived: includeArchived } }).then((r) => r.data),

  createSession: (title) =>
    api.post(`/workspace/sessions`, { title }).then((r) => r.data),

  getSession: (id) =>
    api.get(`/workspace/sessions/${id}`).then((r) => r.data),

  updateSession: (id, patch) =>
    api.patch(`/workspace/sessions/${id}`, patch).then((r) => r.data),

  deleteSession: (id) =>
    api.delete(`/workspace/sessions/${id}`).then((r) => r.data),

  createArtifact: (sessionId, artifact) =>
    api.post(`/workspace/sessions/${sessionId}/artifacts`, artifact).then((r) => r.data),

  uploadArtifacts: (sessionId, files) => {
    const fd = new FormData();
    for (const f of files) fd.append("files", f, f.name);
    return api
      .post(`/workspace/sessions/${sessionId}/artifacts/upload`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },

  updateArtifact: (sessionId, artifactId, patch) =>
    api.patch(`/workspace/sessions/${sessionId}/artifacts/${artifactId}`, patch).then((r) => r.data),

  closeArtifact: (sessionId, artifactId) =>
    api.delete(`/workspace/sessions/${sessionId}/artifacts/${artifactId}`).then((r) => r.data),

  emitEvent: (sessionId, event) =>
    api.post(`/workspace/sessions/${sessionId}/events`, event).then((r) => r.data),

  getUnderstanding: (sessionId) =>
    api.get(`/workspace/sessions/${sessionId}/understanding`).then((r) => r.data),

  ask: (sessionId, query) =>
    api.post(`/workspace/sessions/${sessionId}/ask`, { query }).then((r) => r.data),

  feedback: (sessionId, payload) =>
    api.post(`/workspace/sessions/${sessionId}/understanding/feedback`, payload).then((r) => r.data),
};
